export default "__VITE_ASSET__BrYQfEpo__"